import React from 'react';

import { FilterProvider, FilterProviderProps } from '../FilterProvider';
import { PaginationProvider, PaginationProviderProps } from '../PaginationProvider';
import { SearchProvider } from '../SearchProvider';

interface TableDataProviderProps {
  filterProviderProps?: FilterProviderProps;
  paginationProviderProps?: PaginationProviderProps;
}

export const TableDataProvider: React.FC<React.PropsWithChildren<TableDataProviderProps>> = ({
  children,
  filterProviderProps,
  paginationProviderProps,
}) => {
  return (
    <FilterProvider {...filterProviderProps}>
      <SearchProvider>
        <PaginationProvider {...paginationProviderProps}>{children}</PaginationProvider>
      </SearchProvider>
    </FilterProvider>
  );
};
